import { Observable, Subject, from } from 'rxjs';
import { WebViewer } from '@reactivereality/pictofit-web-sdk';
import { Injectable } from '@angular/core';
import { SizingModel } from '../models/sizing.model';

@Injectable({
  providedIn: 'root',
})
export class ScreenshotService {
  public settingsChanged: Subject<SizingModel> = new Subject<SizingModel>();
  public getScreenshot(
    viewer: WebViewer,
    sizing: SizingModel,
  ): Observable<string> {
    return from(viewer.takeScreenshot(sizing));
  }
}
